/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import React, { useState, useEffect } from 'react';
import _join from 'lodash/join';
import _isNaN from 'lodash/isNaN';
import PropTypes from 'prop-types';
import { useInput, Labeled } from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

const useStyles = makeStyles((theme) => ({
  separator: {
    margin: '0 10px',
  },
}));

const PhysicalSizeInput = (props) => {
  const classes = useStyles();
  const [values, setValues] = useState(['', '', '']);

  const {
    input: { onChange, value },
    meta: { touched, error },
  } = useInput(props);

  useEffect(() => {
    if (value) {
      const values = value.split('/');
      setValues(values);
    }
  }, [value]);

  const handleFirstInput = (e) => {
    const val = e.target.value;
    handleChangeInput(0, val);
  };

  const handleSecondInput = (e) => {
    const val = e.target.value;
    handleChangeInput(1, val);
  };

  const handleThirdInput = (e) => {
    const val = e.target.value;
    handleChangeInput(2, val);
  };

  const handleChangeInput = (index, value) => {
    if (_isNaN(parseFloat(value))) {
      return;
    }
    values[index] = value;
    onChange(_join(values, '/'));
    setValues(values);
  };

  const { label } = props;

  return (
    <React.Fragment>
      <Labeled label={label} meta={{ touched, error }}>
        <React.Fragment>
          <TextField
            type="number"
            inputProps={{ step: 0.01 }}
            value={values[0]}
            onChange={handleFirstInput}
          />
          <span className={classes.separator}>/</span>
          <TextField
            type="number"
            inputProps={{ step: 0.01 }}
            value={values[1]}
            onChange={handleSecondInput}
          />
          <span className={classes.separator}>/</span>
          <TextField
            type="number"
            inputProps={{ step: 0.01 }}
            value={values[2]}
            onChange={handleThirdInput}
          />
        </React.Fragment>
      </Labeled>
      {touched && error && (
        <p
          class="MuiFormHelperText-root MuiFormHelperText-contained Mui-error MuiFormHelperText-marginDense"
          id="extraData.ref-helper-text"
        >
          {error}
        </p>
      )}
    </React.Fragment>
  );
};

PhysicalSizeInput.propTypes = {
  record: PropTypes.object,
  source: PropTypes.string.isRequired,
};

PhysicalSizeInput.defaultProps = {
  record: {},
};

export default PhysicalSizeInput;
